import styled from "styled-components/macro";
import { PROVIDER_MOBILE_MENU_Z_INDEX } from "../../pages/Help/Help.constants";

export const transitionName = "mobile-menu";
export const appearDuration = 400;
export const MenuContainer = styled.div`
  position: fixed;
  top: 63px;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.blueDark};
  width: 100vw;
  height: calc(100vh - 63px);
  height: calc(100dvh - 63px);
  padding: 32px 18px;
  box-sizing: border-box;
  overflow-y: auto;
  z-index: ${PROVIDER_MOBILE_MENU_Z_INDEX};

  &.${transitionName}-enter {
    opacity: 0.01;
  }
  &.${transitionName}-enter.${transitionName}-enter-active {
    opacity: 1;
    transition: opacity ${appearDuration}ms ease-in;
  }
  &.${transitionName}-exit {
    opacity: 1;
  }
  &.${transitionName}-exit.${transitionName}-exit-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }
`;

export const MobileMenuHr = styled.hr`
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.blueMedium};
`;

export const MobileMenuLinkHrContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
